import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    box: {
      padding: theme.spacing(1),
      border: '1px solid',
      borderColor: '#f1f1f1',
      borderRadius: 5,

      backgroundColor: '#f8f8f8',
      justifyContent: 'space-between',
      alignItems: 'center',

      '& > button': {
        textAlign: 'left',
        textTransform: 'initial',
        justifyContent: 'flex-start',
      },
    },
    avatar: {
      width: theme.spacing(6.5),
      height: theme.spacing(6.5),
      background: theme.palette.primary.light,
      objectPosition: 'top',
    },

    titleContainer: {
      marginBottom: theme.spacing(4),
      alignItems: 'center',
    },
    title: {
      padding: '10px 10px 10px 0',
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(22),
      fontWeight: 'bold',
      textAlign: 'left',
    },

    buildingTitle: {
      fontWeight: 'bold',
    },

    subtitle: {
      maxWidth: 255,
      marginTop: theme.spacing(0.5),
      justifyContent: 'space-between',

      '& svg': {
        marginRight: theme.spacing(1),
        color: theme.palette.text.secondary,
      },
    },

    statusIdComponent: {
      marginTop: theme.spacing(1.5),
      justifyContent: 'center',

      [theme.breakpoints.up('sm')]: {
        marginTop: 'unset',
      },
    },

    cancelled: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
    },
  })
);

export default useStyles;
